module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.quadVenue && _vm.quadVenue.race) ? _c('div', [_c('div', {
    staticClass: "race-title-bar",
    style: (_vm.raceTitleBar)
  }, [_c('div', {
    staticClass: "race-venue-flag"
  }, [_c('img', {
    attrs: {
      "src": _vm.flagImage(_vm.quadVenue.countryName),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "race-venue-name"
  }, [_c('div', {
    staticClass: "venue-name",
    class: _vm.venueFlash
  }, [_vm._v("\n          " + _vm._s(_vm.venueDisplayName(_vm.quadVenue.ve)) + "\n          "), (_vm.hasNextVenue) ? _c('span', {
    staticClass: "showing-next"
  }, [_vm._v("Showing Next in " + _vm._s(_vm.nextVenueIn) + "s.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "race-name",
    class: _vm.raceFlash
  }, [_vm._v("\n          " + _vm._s(_vm._f("race")(_vm.quadVenue.race.fn)) + " - " + _vm._s(_vm._f("satime")(_vm.quadVenue.race.raceDateTime)) + "\n          "), (_vm.hasNextRace) ? _c('span', {
    staticClass: "showing-next"
  }, [_vm._v("Showing Next in " + _vm._s(_vm.nextRaceIn) + "s.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "race-titles"
  }, [_c('div', {
    staticClass: "place-title"
  }, [_vm._v("\n          PLACE\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "prev-title"
  }, [_vm._v("\n          PREV\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "price-title"
  }, [_vm._v("\n          PRICE\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "race-places-paid"
  }, [_vm._v("\n          " + _vm._s(_vm.quadVenue.race.placesPaid) + " PLACES PAID\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "markets-container"
  }, [_vm._l((_vm.quadVenue.race.markets), function(market) {
    return [(market.include) ? _c('Market', {
      key: market.id,
      attrs: {
        "places-paid": _vm.quadVenue.race.placesPaid,
        "place-percentage": _vm.quadVenue.race.placePercentage,
        "venue-id": _vm.quadVenue.venueId,
        "race-id": _vm.quadVenue.race.raceId,
        "market-id": market.marketId,
        "venue-index": _vm.venueIndex,
        "is-multi": true,
        "quadrant": _vm.quadrant
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('Market', {
    attrs: {
      "scroll-markets": _vm.quadVenue.race.scrollMarkets,
      "places-paid": _vm.quadVenue.race.placesPaid,
      "place-percentage": _vm.quadVenue.race.placePercentage,
      "venue-id": _vm.quadVenue.venueId,
      "race-id": _vm.quadVenue.race.raceId,
      "venue-index": _vm.venueIndex,
      "is-multi": true,
      "quadrant": _vm.quadrant
    }
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.quadVenue) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n    No Venue or Race to Display\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42bcddc8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiScreenSection.vue
// module id = 231
// module chunks = 1